import { gql } from "@apollo/client";

export const CREATE_HOLIDAY_CALENDAR = gql`
  mutation createCalendar($input: createCalendarInput) {
    createCalendar(input: $input) {
      orgId
    }
  }
`;
export const UPDATE_HOLIDAY_CALENDAR = gql`
  mutation updateCalendar($input: updateCalendarInput) {
    updateCalendar(input: $input)
  }
`;
export const GET_HOLIDAY_CALENDAR = gql`
  query holidayCalendarByOrg($orgId: Int, $state: String, $country: String) {
    holidayCalendarByOrg(orgId: $orgId, state: $state, country: $country) {
      orgId
      event
      country
      state
    }
  }
`;
export const GET_HOLIDAY_CALENDAR_BY_OFFICE = gql`
  query HolidayCalendarByOffice($userId: String) {
    holidayCalendarByOffice(userId: $userId) {
      country
      event
      orgId
      state
    }
  }
`;
